<div class="node-icon visited">
	<span class="node-icon-connector active"></span>
	<svg class="svg-tick-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
		<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
	</svg>
</div>
